import React from 'react';
import { Link } from 'react-router-dom';
import { useBreakpoints } from '../../hooks/useBreakpoints';
import Container from '../containers/container';
import Icon from '../icons/icon';
import AltAvatar from '../images/alt-avatar';
import { VStack } from '../layouts/stack.layout';
import Button from './v2/button';

type Props = {
  imageSrc: string;
  name: string;
  username: string;
  onClick?: Function;
};

const styles = {
  label:
    'font-text text-xs text-center font-medium whitespace-nowrap text-primary',
  'add-button-mobile':
    'absolute top-0 right-0 bg-secondary rounded-full p-[2px]',
};

export default function AddArtistButton({ imageSrc, username, name }: Props) {
  const { isMobile, isTabletLg } = useBreakpoints();
  return (
    <VStack gap="sm" align="center">
      <Container extensions="relative">
        <Link to={`/${username}`}>
          <AltAvatar url={imageSrc} />
        </Link>
        {isMobile && !isTabletLg && (
          <div className={styles['add-button-mobile']}>
            <Icon icon="add" color="primary" size="sm" />
          </div>
        )}
      </Container>
      <div className={styles['label']}>{name}</div>
      {isTabletLg && (
        <Button variant="outline" size="sm">
          Track
        </Button>
      )}
    </VStack>
  );
}
